export default class Dimensions {
    static getNavHeight() {
        const navElement = document.getElementById('head-nav-band');

        return navElement && window.getComputedStyle(navElement).position === 'fixed'
            ? navElement.offsetHeight
            : 0;
    }
}
